/****************************************************
 * Module Name:  addPermissionModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import PermissionProxy from "../../utility/proxy/manager/permissionProxy/permissionProxy";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddPermissionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newpermission: this.props.editOperation ? this.props.sourceData.name : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validatePermissionPresentSpinner: false,
      showValidationMessage: false,
      permissionAvailable: true,

      permissionValidationError: "",
    };
    if (this.props.sourceData === undefined) {
      this.getPermissionById();
    }
  }

  getPermissionById = () => {
    PermissionProxy.GetSinglePermission(this.props.permissionId, (response) =>
      this.setState({
        newpermission:
          response !== null && response !== undefined && response.name !== null
            ? response.name
            : "",
        newdescription:
          response !== null &&
            response !== undefined &&
            response.description !== null
            ? response.description
            : "",
      })
    );
  };

  handleSave = () => {
    let data = {
      id:
        this.props.sourceData === undefined
          ? this.props.permissionId
          : this.props.editOperation
            ? this.props.sourceData.id
            : undefined,
      name: this.state.newpermission,
      description: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validatePermissionPresent = (permissionEntered) => {
    if (!permissionEntered || permissionEntered.trim() === "") return;

    this.setState({
      validatePermissionPresentSpinner: true,
    });

    PermissionProxy.CheckPermissionAvailable(permissionEntered, (response) => {
      //if we got response that means permission is present at backend
      if (response) {
        //PermissionName already present
        this.setState({
          validatePermissionPresentSpinner: false,
          showValidationMessage: true,
          permissionAvailable: false,
        });
      } else {
        //PermissionName not available, so can be used
        this.setState({
          validatePermissionPresentSpinner: false,
          showValidationMessage: true,
          permissionAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.sourceData === undefined) {
      return false;
    } else if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage || !this.state.permissionAvailable
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add permission validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation || this.props.sourceData === undefined
                ? "Edit Permission"
                : "Add New Permission"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Permission Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {!this.props.sourceData && (
                    <tr>
                      <td>
                        <Form.Label>Permission Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.permissionId}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {(this.props.editOperation || !this.props.sourceData) && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Permission <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation || !this.props.sourceData ? (
                      <td>
                        <Form.Label>{this.state.newpermission}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          label="Permission (required)"
                          placeholder="Enter Permission"
                          value={this.state.newpermission}
                          autoFocus
                          onBlur={(e) =>
                            this.validatePermissionPresent(
                              this.state.newpermission
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newpermission: e.target.value,
                              showValidationMessage: false,
                              permissionValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Permission Cannot be Empty",
                            })
                          }
                          helperText={this.state.permissionValidationError}
                          error={
                            this.state.permissionValidationError.length > 0
                          }
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validatePermissionPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.permissionAvailable ? (
                        <font color="green">Permission available</font>
                      ) : (
                        <font color="red">Permission not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
